//@import dependencies
import React, {useState} from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import AlertComponent from 'app_components/commons/alert'
import AvatarComponent from 'app_components/commons/avatar'
import IconComponent from 'app_components/commons/icons'
import UserInfoSkeleton from './userInfoSkeleton'
import ModalUserForm from 'app_components/modules/campus/user/modalUserForm'
import ModalUserCertificationsModule from 'app_components/modules/modalUserCertifications'
import { MdOutlineEdit } from 'react-icons/md'
//@end

// @import hooks
import {useColors} from 'app_hooks/useColors'
// @end

// @INFO Import types
import {IUserInfo} from 'app_types/campus/user/userInfoTypes'
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import '../userInfoModule.scss'
import ButtonComponent from 'app_components/commons/Button/ButtonComponent'
import { UserFormSections } from 'app_types/userTypes'
import TextComponent from 'app_components/commons/TextComponent/TextComponent'

// @ADD Component types
interface IUserInfoModuleLayoutProps {
  status: null | 'loading' | 'error'
  userInfo: IUserInfo | null
  onUserUpdated: (data: any) => void
  className?: string
  hideCertifications?: boolean
  showEditButton?: boolean
  showChangePassword?: boolean
  id?: string
}

const UserInfoModuleLayout: React.FC<IUserInfoModuleLayoutProps> = ({
  className,
  hideCertifications,
  showEditButton,
  showChangePassword,
  ...props
}) => {

  const [colors] = useColors()
  const logo = require('app_assets/images/logos/logo_campus.png')

  const { t } = useTranslation()

  const [userFormStatus, setUserFormStatus] = useState<boolean>(false)
  const [userCertificationsStatus, setUserCertificationsStatus] = useState<boolean>(false)
  const [origin, setOrigin] = useState<UserFormSections>(UserFormSections.GENERAL_INFO)

  const handleUserForm = (origin: UserFormSections) => {
    setOrigin(origin)
    setUserFormStatus(true)
  }

  const handleCloseModal = (data: any) => {
    setUserFormStatus(false)
    props.onUserUpdated(data)
  }

  const handleCloseUserCertificationsModal = (data: any) => {
    setUserCertificationsStatus(false)
  }

  return(
    <div id={props.id} className={`user_info-component ${className ? className : ''}`}>
      {props.status === 'loading' ? (
        <UserInfoSkeleton />
      ) : (
        <>
          {props.userInfo ? (
            <>
              <div>
                <div className="company-logo">
                  <img src={logo} alt="CompanyLogo" />
                </div>
                {props.userInfo.avatar && (
                  <div className="avatar-container">
                    <AvatarComponent src={props.userInfo.avatar} circle={true} />
                    {!showEditButton && (<div className="user-button-edit" onClick={() => handleUserForm(UserFormSections.GENERAL_INFO)}>
                      <IconComponent
                        svg="EditBackground"
                        color={colors.secondary}
                        width='1.7rem'
                      />
                    </div>)}
                  </div>
                )}
              </div>
              <div className="user-info-main">
                <p className="title">{t("modules.userInfo.title")}</p>
                {props.userInfo.fullName && (
                  <p className="user-field important">{props.userInfo.fullName}</p>
                )}
                {props.userInfo.program && (
                  <p className="user-field">{props.userInfo.program}</p>
                )}
                {props.userInfo.cell_phone && (
                  <p className="user-field">{props.userInfo.cell_phone}</p>
                )}
                {props.userInfo.email && (
                  <p className="user-field">{props.userInfo.email}</p>
                )}
                {props.userInfo.roles && (
                  <p className="user-field">
                    <IconComponent svg="UserCircle" width="20" color={colors.primary}/> &nbsp;
                    {props.userInfo.roles}
                  </p>
                )}
                {!hideCertifications && props.userInfo.hasCertifications && (
                  <div className="certifications-container">
                    <button
                      className="btn btn-primary certifications"
                      onClick={() => setUserCertificationsStatus(true)}
                    >
                      {t("modules.userInfo.certifications")}
                    </button>
                  </div>
                )}
                {showEditButton && (
                  <ButtonComponent className='user-info-module--button-edit' onClick={() => handleUserForm(UserFormSections.GENERAL_INFO)}>
                    <ButtonComponent.Icon>
                      <MdOutlineEdit />
                    </ButtonComponent.Icon>
                    Editar perfil
                  </ButtonComponent>
                )}
                {props.userInfo.lastLogin && (
                  <div className="last-login-container">
                    <span>{t("modules.userInfo.last_login")}: {props.userInfo.lastLogin}</span>
                  </div>
                )}
                {showChangePassword && (
                  <TextComponent className='user-info-module--security' onClick={() => handleUserForm(UserFormSections.SECURITY)}>
                    Quiero cambiar mi contraseña
                  </TextComponent>
                )}
              </div>
              {userFormStatus && (
                <ModalUserForm
                  id="user_info_modal_user_form"
                  open={userFormStatus}
                  handleClose={handleCloseModal}
                  origin={origin}
                />
              )}
              {userCertificationsStatus && props.userInfo.hasCertifications && (
                <ModalUserCertificationsModule
                  open={userCertificationsStatus}
                  handleClose={handleCloseUserCertificationsModal}
                  certifications={props.userInfo.certifications}
                />
              )}
            </>
          ) : (
            <div>
              <AlertComponent
                type='warning'
                title={t(`modules.userInfo.no_data`)}
              />
            </div>
          )}
        </>
      )}



    </div>
  )
}

export default UserInfoModuleLayout
